import { PreventabilityDisruptionFactorType } from 'client/dto';
import { Typography } from 'components/_common/Typography';
import React from 'react';

type PreventabilitySummaryProps = {
  preventability: PreventabilityDisruptionFactorType;
};

const PreventabilitySummary: React.FC<PreventabilitySummaryProps> = ({ preventability }) => {
  switch (preventability) {
    case PreventabilityDisruptionFactorType.NoVaccineOrProphylaxis: {
      return (
        <div data-testid="preventability-summary">
          <Typography variant="subtitle1" inline>
            No vaccine or prophylaxis
          </Typography>{' '}
          available
        </div>
      );
    }
    case PreventabilityDisruptionFactorType.LimitedVaccine: {
      return (
        <div data-testid="preventability-summary">
          <Typography variant="subtitle1" inline>
            A vaccine is available, but is limited
          </Typography>{' '}
          to high risk occupations or groups
        </div>
      );
    }
    case PreventabilityDisruptionFactorType.WideVaccine: {
      return (
        <div data-testid="preventability-summary">
          <Typography variant="subtitle1" inline>
            Wide commercial vaccine
          </Typography>{' '}
          availability
        </div>
      );
    }
    case PreventabilityDisruptionFactorType.WideProphylaxis: {
      return (
        <div data-testid="preventability-summary">
          <Typography variant="subtitle1" inline>
            Wide commercial prophylaxis
          </Typography>{' '}
          availability
        </div>
      );
    }
    default: {
      return null;
    }
  }
};

export default PreventabilitySummary;
